export const HEADERS = ["Краткое наименование", "Полное наименование", "Код"];
